<template lang="html">
  <div :class="`categories-main row ${isFetching ? 'fetching' : ''}`">
    <template v-for="(cat, index) in categories">
      <div :key="'cat-' + index" class="category col-6 col-md">
        <div @click="$emit('selected', cat.id)">
          <font-awesome-icon class="root-category-icon" :icon="[ 'fas', `${ cat.icon }` ]"  size="3x" />
          <p class="text-center" style="cursor: pointer">{{ cat.name }}</p>
        </div>
      </div>
    </template>
    <div class="col-12 col-sm-4 offset-sm-4 my-3 text-center" style="height: 100%">
      <SquaredButton
        @click="$emit('discard')"
        styleType="link"
        label="Anterior" />
    </div>
    <Loading :active="isFetching" />
  </div>
</template>

<script>
  import store from '@/store'
  import {urls, api} from '@/api'
  import {instance as actionDialog} from '@/components/layout/ActionDialog'

  export default {
    props: {
      deletePending: Boolean
    },

    data: () => ({
      categories: [],
      pendingPub: null,
      isFetching: false
    }),

    computed: {
      pubId: () => store.state.sell.id,

      mainEmail: () => store.state.user.emails.filter(e => e.email === store.state.user.email)[0],

      phones: () => store.state.user.phones,

      name: () => store.getters['user/name'],

      canSell () { return this.mainEmail && this.mainEmail.verified && this.phones.filter(p => p.verified).length > 0 && this.name },

      step () { return this.$route.params.step },

      pubMlaId: () => store.state.sell.mla_category_id
    },

    watch: {
      deletePending (status) {
        if (status === true && this.pubId) {
          this.discardPub(this.pubId)
            .then(this.resetState)
        } else if (status === true) {
          this.fetchCategories()
        }
      }
    },

    created () {
      if (this.$route.name === 'editPublication') return true
      store.dispatch('setIsFetching', true)
      store.dispatch('user/fetchUserInfo')
        .then(() => {
          if(!this.pubId) {
            this.fetchCategories()
          }
        })
        .catch(() => { store.dispatch('setIsFetching', false) })
    },

    methods: {
      fetchCategories () {
        if (!this.canSell) {
          actionDialog({
            statement: 'Para poder publicar en nuestro sitio, necesitás agregar un nombre, un correo electrónico y un teléfono móvil (y verificarlos) en tu perfil de usuario',
            positiveLabel: 'Ir al perfil',
            positiveAction: () => { this.$router.push({ name: 'userProfile' }) },
            noClose: true
          })
          return
        }

        if (this.categories.length > 0) return

        this.isFetching = true

        api.get(urls.sellCategories)
          .then(({data}) => {
            this.categories = data.data
            if (this.step !== 'categoria')
              this.$router.push({name: 'sell', params: {step: 'categoria'}})
          })
          .catch(err => {
            if (err.response.status === 403) {
              this.pendingPub = err.response.data.error &&
                err.response.data.error.publication_id

              if (this.pendingPub && this.$route.name != 'authorization') {
                //if trying to create post, having a pending
                this.handlePendingPub()
              } else{
                //if we are redirected from the link with mercadopago
                this.getPendingPub()
              }
            }
          })
          .finally(() => {
            store.dispatch('setIsFetching', false)
            this.isFetching = false
          })
      },

      handlePendingPub () {
        const dialog = actionDialog({
          statement: 'Tenés una publicación pendiente, ¿querés continuar?',
          positiveLabel: 'Continuar',
          negativeLabel: 'Descartar',
          positiveAction: this.getPendingPub,
          negativeAction: this.discardPendingPub,
          noClose: true
        })

        dialog.$mount(this.$refs.dialogs)
      },

      getPendingPub () {
        this.isFetching = true
        store.dispatch('sell/getDraft', this.pendingPub)
          .then(res => {
            this.$emit('continue')
            if (this.step === 'confirmacion' && this.pubMlaId) {
              store.dispatch('sell/getRemainingPubs', this.pubMlaId)
              store.dispatch('sell/getCheapestHighlight')
            }
            this.pushToDataLayer('Sell page', 'Draft continue')
          })
          .finally(() => { this.isFetching = false })
      },

      discardPub (id) {
        this.isFetching = true
        return api.delete(`${urls.sell}/${id}`)
          .then(res => {
            this.$emit('discard')
            this.pushToDataLayer('Sell page', 'Draft discard')
          })
          .catch(err => {})
          .finally(() => { this.isFetching = false })
      },

      discardPendingPub () {
        return this.discardPub(this.pendingPub)
          .then(this.fetchCategories)
      },

      resetState () {
        store.dispatch('sell/resetInitialState')
          .then(this.fetchCategories)
          .then(() => { this.$emit('resetted') })
      }
    }
  }
</script>

<style lang="scss">
  @import '../../scss/breakpoints';

  .fetching {
    cursor: progress !important;
  }

  .categories-main {
    min-height: 40vh;
    color: #199348;
  }

  .root-category-icon {
    height: 42px;
    margin: auto;
    display: block;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/pages/sellPage/RootCategories.vue